import { NAME } from './constants';

export const APPEND_POLICIES = `${NAME}/APPEND_POLICIES`;
export const RESET = `${NAME}/RESET`;
export const RESET_WITHOUT_SELLER_NUMBERS = `${NAME}/RESET_WITHOUT_SELLER_NUMBERS`;
export const RESET_WITHOUT_SELLER_NUMBERS_AND_SEARCHED_CRITERIAS = `${NAME}/RESET_WITHOUT_SELLER_NUMBERS_AND_SEARCHED_CRITERIAS`;
export const SET_POLICIES = `${NAME}/SET_POLICIES`;
export const SET_SORT = `${NAME}/SET_SORT`;
export const SET_SELLER_NUMBERS = `${NAME}/SET_SELLER_NUMBERS`;
export const SAVE_SEARCHED_CRITERIAS = `${NAME}/SAVE_SEARCHED_CRITERIAS`;
export const REMOVE_FILTER_CRITERIA_BY_KEY = `${NAME}/REMOVE_FILTER_CRITERIA_BY_KEY`;
export const SAVE_FOCUS_FIELD = `${NAME}/SAVE_FOCUS_FIELD`;
